import { useFormikContext } from 'formik';
import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';
import PlainButton from 'packages/kakapo-ui-kit/components/buttons/PlainButton';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalFooter from 'packages/kakapo-ui-kit/components/modals/ModalFooter';
import ModalHeader from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import PrimaryButton from 'packages/kakapo-ui-kit/components/buttons/PrimaryButton';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

export default function EvaluationSubmissionSignatureModal(props: {
	submission: graphql.EvaluationSubmission;
	saving: boolean;
	acquire: () => Promise<void>;
	onErrors: (errors: Set<string>) => void;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const formik = useFormikContext<any>();
	const [commit, { loading }] = graphql.useUpdateEvaluationSubmissionMutation({});

	const onConfirm = async () => {
		props.onErrors(new Set());

		await props.acquire();
		try {
			await commit({
				variables: {
					input: {
						id: props.submission.id,
						sections: formik.values.sections,
						signed: true,
					},
				},
			});

			window.scrollTo(0, 0);
			props.onDismiss();
		} catch (error: any) {
			const errors = new Set<string>(
				error.graphQLErrors[0].extensions.error.data.details.map(
					({ path }: { path: (string | number)[] }) =>
						path
							.slice(0, 4)
							.map((element) => (typeof element === 'number' ? `[${element}]` : `.${element}`))
							.join('')
							.substring(1),
				),
			);
			props.onErrors(errors);
		}

		window.scrollTo(0, 0);
		props.onDismiss();
	};

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader>{t('evaluation.submission.confirm.modal.title')}</ModalHeader>
				<ModalContent>
					<Paragraph>{t('evaluation.submission.confirm.modal.description')}</Paragraph>
				</ModalContent>
				<ModalFooter>
					{props.saving || loading ? (
						<Spinner isLoading size="18px" />
					) : (
						<Flex px={3} alignItems="center" justifyContent="flex-end">
							<Box mr={3}>
								<PlainButton onClick={() => props.onDismiss()}>
									{t('evaluation.submission.confirm.modal.cancel')}
								</PlainButton>
							</Box>
							<PrimaryButton onClick={onConfirm}>
								{t('evaluation.submission.confirm.modal.confirm')}
							</PrimaryButton>
						</Flex>
					)}
				</ModalFooter>
			</Modal>
		</ModalBackground>
	);
}
